<template>
    <v-dialog v-model="show" no-click-animation persistent width="500">
        <v-card>
            <v-layout class="headline grey lighten-2 pl-3 pr-2 py-2" primary-title align-center>
                <div>{{item ? $t('creator.entity') : $t('editor.entity') }}</div>
                <v-spacer></v-spacer>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-layout>
            <v-card-text>
                <v-form v-model="formValid" @submit="submit" ref="form">
                    <v-text-field
                        :label="$t('name') | capitalize"
                        v-model="label"
                        :rules="formRules.required"
                    ></v-text-field>
                    <v-text-field
                        :label="$t('description') | capitalize"
                        v-model="description"
                    ></v-text-field>
                    <div class="mt-3">
                        <div style="font-size: 16px; color: rgba(0,0,0,0.54)">Look up strategy</div>
                        <v-radio-group v-model="type" :rules="formRules.required">
                            <v-radio :label="$t('exact') | capitalize" :value="2"></v-radio>
                            <v-radio :label="$t('predictive') | capitalize" :value="3"></v-radio>
                            <v-radio :label="$t('both') | capitalize" :value="1"></v-radio>
                        </v-radio-group>
                    </div>
                    <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn class="ma-0" type="submit">{{ $t('save') }}</v-btn>
                    </v-layout>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";
import NLP_Service from "@/services/nlp.service";

export default {
    name: "EntityEditor",
    mixins: [DialogPromiseFormMixin],
    data () {
        return {
            item: null,
            label: '',
            description: '',
            type: 1
        }
    },
    methods: {
        open (item) {
            this.item = item
            this.clearForm()
            if (this.item) {
                this.label = item.label
                this.description = item.description
                this.type = item.type || 1
            } else {
                this.type = 1
            }
            // tại sao lại cần cái oldType này?
            // vì cái củ kẹc v-radio-group sau khi bị reset nó mất cmnl ui nếu giá trị mới không đổi
            let oldType = this.type
            this.type = -1
            this.show = true
            this.$forceUpdate()
            this.$nextTick(() => {
                this.type = oldType
            })
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        submitValidForm () {
            let model, promise, i18n
            if (this.item) {
                model = {
                    type: this.type,
                    description: this.description
                }
                i18n = {
                    action: this.$t('update'),
                    item: this.$t('entity')
                }
                this.$appService.showLoading()
                promise = NLP_Service.EntityService.replace(this.$route.params.scenarioId, this.item.label, model)
            } else {
                model = {
                    type: this.type,
                    label: this.label,
                    description: this.description
                }
                i18n = {
                    action: this.$t('create'),
                    item: this.$t('entity')
                }
                promise = NLP_Service.EntityService.create(this.$route.params.scenarioId, model)
            }
            this.$appService.showLoading()
            promise.then(
                result => {
                    this.close()
                    this.$appService.handleRequestError(this.$t('actionSuccessful', i18n))
                    this.promise.resolve(result.data)
                },
                this.$appService.handleRequestError(this.$t('actionFailed', i18n))
            ).finally(this.$appService.hideLoading)
            this.clearForm()
        }
    }
}
</script>

<style scoped>

</style>
